// GENERATED by scripts/write-version.js from package.json "version" — do not edit.
// Bump with `npm version patch`; the "version" lifecycle script regenerates this file.
export const APP_VERSION = '1.0.148';
